<section class="agpr-checkboxFilter">
    <ng-container *ngIf="options.length > 0 && includeSelectAll">
        <agpr-button
            id="checkBoxFilter.toggleButton"
            [style]="buttonTypes.link"
            [label]="value.length === 0 ? 'selectAll' : 'selectNone'"
            (click)="value.length === 0 ? checkAll() : uncheckAll()"
        ></agpr-button>
    </ng-container>
    <ul
        class="agpr-checkboxFilter-options"
        [attr.aria-label]="'filter' | localize"
    >
        <li
            *ngFor="let option of options; index as i"
            class="agpr-checkboxFilter-option"
        >
            <agpr-checkbox
                name="group"
                [id]="'checkBoxFilter_option_' + i"
                [value]="options[i]"
                [label]="option[labelField]"
                [(ngModel)]="value"
                (ngModelChange)="onModelChange(value)"
            ></agpr-checkbox>
        </li>
    </ul>
</section>
